import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Post from '@/components/Post.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      title: 'Dylan Cauwels'
    }
  },
  {
    path: '/work',
    name: 'Work',
    component: () => import(/* webpackChunkName: "work" */ '../views/Work.vue'),
    meta: {
      title: 'Work'
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
    meta: {
      title: 'Projects'
    }
  },
  {
    path: '/school',
    name: 'School',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "school" */ '../views/School.vue'),
    meta: {
      title: 'School'
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue'),
    children: [
      {
        path: ':postName',
        component: Post,
        props: true,
        meta: {
          showModal: true,
          title: 'Blog'
        }
      }
    ],
    meta: {
      title: 'Blog'
    }
  },
  // {
  //   path: '*',
  //   name: 'Error',
  //   componenet: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
  //   meta: {
  //     title: 'Error'
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

